import { Trigger } from '@radix-ui/react-popover'
import type { ComponentPropsWithoutRef } from 'react'

export type PopoverTriggerProps = ComponentPropsWithoutRef<typeof Trigger>

export const PopoverTrigger = Trigger
